/**
 * Tour registry.
 *
 * Add a new tour here: import its definition and drop it into `allTours`.
 * That's the only wiring needed for the manager to know about it — the on/off
 * switch and scheduling live in the per-environment files under `../config/`.
 */

import type { TourDefinition } from '../core/types';
import { announcementsTour } from './announcements.tour';

export const allTours: TourDefinition[] = [announcementsTour];
